import React from 'react';
import { MDBIcon, MDBToast } from 'mdb-react-ui-kit';

const Toast = ({ toast, resetToast, autoHide = true, hasHeader }) => {
  let icon;
  if (toast.type === 'success') {
    icon = <MDBIcon far icon="check-circle" size='lg' />;
  } else if (toast.type === 'danger') {
    icon = <MDBIcon far icon="times-circle" size='lg' />;
  }

  const bodyContent = (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <span style={{ flex: 1 }}>{toast.message}</span>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {hasHeader ? icon : null}
        {!hasHeader && typeof resetToast === 'function' && (
          <button 
            type="button" 
            aria-label="Close"
            onClick={() => resetToast()}
            style={{ 
              background: 'rgba(255, 255, 255, 0.2)', 
              border: 'none', 
              borderRadius: '50%',
              cursor: 'pointer',
              color: 'inherit',
              padding: '4px',
              lineHeight: '1',
              opacity: '0.8',
              width: '24px',
              height: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            onMouseEnter={(e) => e.target.style.opacity = '1'}
            onMouseLeave={(e) => e.target.style.opacity = '0.8'}
          >
            <MDBIcon fas icon="times-circle" />
          </button>
        )}
      </div>
    </div>
  );
  return (
    <MDBToast
      color={toast.type}
      open={toast.isOpen}
      onClose={() => {
        if (typeof resetToast === 'function') {
          resetToast();
        } else {
          console.warn('resetToast function not provided to Toast component');
        }
      }}
      autohide={autoHide}
      position={toast.position}
      delay={5000}
      appendToBody
      headerContent={
        hasHeader ?
          <>
            <strong className='me-auto'>You have a new notification</strong>
          </>
          :
          null
      }
      bodyContent={bodyContent}
    />
  );
};

export default Toast;
